// extracted by mini-css-extract-plugin
export default {"container":"SidebarPanel_container__5BsxU","active":"SidebarPanel_active__w8VK7"};